export { default } from './StaticText';
